<template>
  <div
    v-if="model.ingredientsTitle"
    class="c-product-ingredients"
  >
    <strong class="c-product-nutrition-title e-label-heading u-font-size-xlarge u-flex u-width-max">{{ model.ingredientsTitle }}</strong>
    <div
      class="u-font-size-medium u-mt--xs"
      v-html="model.ingredientsText"
    />
    <div
      v-if="model.fittingLogos && model.fittingLogos.length > 0"
      class="c-product-fitting-logos"
    >
      <template v-for="(logo, index) in model.fittingLogos">
        <a
          v-if="logo.link && logo.link.url"
          :key="`link-${index}`"
          :href="logo.link.url"
          v-bind="logo.link.attributes"
          class="c-product-fitting-logo"
        >
          <Picture
            v-if="logo.image && logo.image.url"
            :src="logo.image"
            :resizer="logo.imageResizer.name"
            :mobile="[90, 90]"
            :options="logoOptions"
            :alt="logo.altText || ''"
          />
        </a>
        <span
          v-else
          :key="`span-${index}`"
          class="c-product-fitting-logo"
        >
          <Picture
            v-if="logo.image && logo.image.url"
            :src="logo.image"
            :resizer="logo.imageResizer.name"
            :mobile="[90, 90]"
            :options="logoOptions"
            :alt="logo.altText || ''"
          />
        </span>
      </template>
    </div>
  </div>
</template>

<script>
import Picture from '@/components/Picture.vue'

export default {
  components: {
    Picture
  },
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      logoOptions: { mode: 'max' }
    }
  }
}
</script>
